"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImperial = isImperial;
exports.numberToDistance = numberToDistance;
exports.numberToPercentage = numberToPercentage;
exports.perUnitFormat = perUnitFormat;

var _base = require("./base");

var unitMap = {
  DISTANCE_KILOMETER: "kilometer",
  DISTANCE_METER: "meter",
  DISTANCE_MILE: "mile",
  DISTANCE_LOCAL: "local",
  //自动匹配当地国家的长度单位
  UNIT_METER: "perMeter",
  UNIT_KILOMETER: "perKilometer",
  UNIT_MILE: "perMile"
};

function numberToDistance(number, unit, precision, isHighLight) {
  var pattern = (0, _base.getDistancePattern)();
  var numberPattern = (0, _base.getNumberPattern)();
  number -= 0;
  unit = unit ? unitMap[unit] : number > pattern.m_threshold ? "kilometer" : "meter";
  var originUnit = unit;

  if ((0, _base.isEN)()) {
    unit = "mile";
  } else if (unit === "mile" || unit === "local") {
    if (number > pattern.m_threshold) {
      unit = "kilometer";
    } else {
      unit = "meter";
    }
  }

  if (unit === "kilometer") {
    number /= 1000;
  }

  var yd = "";

  if (unit === "mile") {
    if (number <= 1609.343 && originUnit !== "mile") {
      number /= 0.9144;
      yd = "yd";
    } else {
      number *= 0.0006214;
    }
  }

  number = (number.toFixed(precision) - 0).toLocaleString('en-US');
  var decimalsLength = number.slice(number.indexOf(".")).length - 1;
  if (numberPattern && numberPattern.group) number = number.replace(",", numberPattern.group);

  if (numberPattern && numberPattern.decimal && decimalsLength) {
    var reg = new RegExp("\\.(\\d{".concat(decimalsLength, "})$"));
    number = number.replace(reg, "".concat(numberPattern.decimal, "$1"));
  }

  return pattern[isHighLight ? "h".concat(unit) : unit].replace(/[#,.0]+/, number).replace(yd ? "mi" : "", yd); // NumberFormat 暂不支持
  // return new Intl.NumberFormat("en-us", {
  //   style: "currency",
  //   unit: "meter",
  //   unitDisplay: "long"
  // }).format(50);
} // 百分比符号,顺序各国不一样


function numberToPercentage(number, isHighLight) {
  var _getBaseInfo = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo.locale;

  var num = new Intl.NumberFormat(locale, {
    style: "decimal"
  }).format(number * 100);
  var percent = new Intl.NumberFormat(locale, {
    style: "percent"
  }).format(number);
  return isHighLight ? percent.replace(num, "{".concat(num, "}")) : percent;
} // 是否英制


function isImperial(country) {
  return !!(0, _base.isEN)(country);
} // 加上单位


function perUnitFormat(string, unit) {
  var pattern = (0, _base.getDistancePattern)();
  var template = pattern[unitMap[unit]];
  return template.replace("{0}", string);
}